import './index.scss';

import { Component } from 'react';
import { BraxButton, BraxForm, BraxModal, BraxSelectField, BraxToastsType, BraxToasts, BraxRadioField } from 'design-system';

import sectors from '../../variables/sectors';
import activities from '../../variables/activities';
import t from '../../utils/i18n';
import handleError from '../../utils/errors';
import { withContexts } from '../../utils/with-context';
import User from '../../view-model/users/User';
import userRegistrationAddonSchema, { UserRegistrationAddonValue } from '../../schemas/users/user-registration-addon';
import usersService from '../../services/users';
import authService from '../../services/auth';
import UserContext from '../../contexts/User';

export type RegistrationAddonProps = {
    toasts: BraxToastsType
    user: User,
    open?: boolean,
    onClose?: () => void
};

type RegistrationAddonState = {
    loading: boolean
};

export default withContexts({
    toasts: BraxToasts,
    user: UserContext
}, class RegistrationAddon extends Component<RegistrationAddonProps, RegistrationAddonState> {

    sectors = [...sectors];

    activities = [...activities];

    state = {
        loading: false
    };

    schema = userRegistrationAddonSchema;

    async save(values: UserRegistrationAddonValue) {
        this.setState({ loading: true });

        try {
            await usersService.setUserGeneralData({
                user: this.props.user.id,
                firstName: this.props.user.firstName,
                lastName: this.props.user.lastName,
                phone: this.props.user.phoneNumber,
                isWhatsapp: this.props.user.isWhatsapp,
                language: this.props.user.language,
                ...values
            });

            authService.updateUserInfo();
        } catch (error) {
            this.props.toasts.create({ type: 'destructive', ...handleError(error) });
        }

        if (this.props.onClose)
            this.props.onClose();

        this.setState({ loading: false });
    }

    render() {
        const yesOrNoOptions = [{
            title: t('Sim'),
            value: 'Sim'
        }, {
            title: t('Não'),
            value: 'Não'
        }];

        return (
            <BraxModal
                open={this.props.open}
                className="registration-addon"
                close={false}
                backdrop={false}
                onClose={this.props.onClose}
            >
                <BraxForm schema={this.schema} onSubmit={values => this.save(values as UserRegistrationAddonValue)}>
                    { (formik) => (<>
                        <h2>{ t('Complete seu cadastro') }</h2>

                        <p className="hint">
                            { t('Precisamos de algumas informações para entender melhor sua demanda e identificar como podemos lhe ajudar.') }
                        </p>

                        <BraxSelectField
                            name="sector"
                            label={t('Setor de atuação')}
                            placeholder={t('Selecione o seu setor')}
                            options={this.sectors}
                        />

                        <BraxSelectField
                            name="activity"
                            label={t('Atividade')}
                            placeholder={t('Selecione a atividade do setor')}
                            options={this.activities.filter(activity => formik.values.sector === activity.sector)}
                            disabled={formik.values.sector === null}
                        />

                        <BraxRadioField
                            name="questions.cf_score_voce_sabe_gerar_imagens_360"
                            label={t('Você sabe gerar imagens 360?')}
                            options={yesOrNoOptions}
                        />

                        <BraxRadioField
                            name="questions.cf_score_ja_utilizou_tour_virtual_360"
                            label={t('Já utilizou Tour Virtual 360?')}
                            options={yesOrNoOptions}
                        />

                        <BraxRadioField
                            name="questions.cf_score_de_que_forma_voce_usa_tours_virtuais"
                            label={t('De que forma você usa Tours Virtuais?')}
                            options={[{
                                title: t('Profissional'),
                                value: 'Profissional'
                            }, {
                                title: t('Pessoal'),
                                value: 'Pessoal'
                            }]}
                        />

                        <BraxRadioField
                            name="questions.cf_score_ja_utilizou_realidade_virtual"
                            label={t('Já utilizou Realidade Virtual?')}
                            options={yesOrNoOptions}
                        />

                        <BraxButton type="submit" disabled={this.state.loading}>
                            { t(this.state.loading ? 'Salvando...' : 'Salvar') }
                        </BraxButton>
                    </>) }
                </BraxForm>
            </BraxModal>
        );
    }

});
